import { Component, ContentChildren, QueryList } from '@angular/core';

import { ListItemDirective } from '~/core/directives/list-item.directive';

@Component({
  selector: 'app-attendee-filters',
  templateUrl: './filters.component.html',
})
export class AttendeeFiltersComponent {
  @ContentChildren(ListItemDirective)
  public filters: QueryList<ListItemDirective>;
}
